/*
* Automatically generated by 'ng g ng-alain:plugin icon'
* @see https://ng-alain.com/cli/plugin#icon
*/

import {
  AppstoreOutline,
  ArrowDownOutline,
  BarChartOutline,
  CloudOutline,
  ContactsOutline,
  CopyrightOutline,
  EditOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  HeartOutline,
  LockOutline,
  LogoutOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  PayCircleOutline,
  PrinterOutline,
  ScanOutline,
  SettingOutline,
  StarOutline,
  TeamOutline,
  ToolOutline,
  UserOutline
} from '@ant-design/icons-angular/icons';

export const ICONS_AUTO = [
  AppstoreOutline,
  ArrowDownOutline,
  BarChartOutline,
  CloudOutline,
  ContactsOutline,
  CopyrightOutline,
  EditOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  HeartOutline,
  LockOutline,
  LogoutOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  PayCircleOutline,
  PrinterOutline,
  ScanOutline,
  SettingOutline,
  StarOutline,
  TeamOutline,
  ToolOutline,
  UserOutline
];
